(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('changeLogStatusMessage', {
            templateUrl: 'app/components/change-log/components/status-message/status-message.html',
            controller: changeLogStatusMessageController,
            bindings: {
                propertyKey: '<',
                oldValue: '<',
                newValue: '<',
                isCreate: '<',
            }
        });

    /** @ngInject */
    function changeLogStatusMessageController($rootScope, $scope, $sce, $translate, $translateSanitization, $element,
                                              $localStorage, moment) {
        var $ctrl = this;
        var unbindTranslate;
        var changeLogPrefix = 'changeLog.';
        var isImmoContext = $localStorage.defaultStore.immoContext;
        var propertyPrefix = $translate.instant('changeLog.propertySymbol');
        const DATE_FORMAT = $translate.instant('momentDateFormat');
        const DATE_TIME_FORMAT = $translate.instant('momentDateTime24HFormat');

        $ctrl.$onInit = setup;

        function setup() {
            if (unbindTranslate) {
                unbindTranslate(); // Removes previous translate listener
            }

            // Assembles the key for the translation
            var translateKey = changeLogPrefix + $ctrl.propertyKey;
            // Tries to translate the key using the immo context key
            var immoTranslateKey = getTranslateKey(isImmoContext, translateKey);
            var translatedValue = $translate.instant(immoTranslateKey);
            if (angular.isString(translateKey) && !translateKey.endsWith('.id')) {
                if (translatedValue !== immoTranslateKey && translatedValue !== '') {
                    buildMessage(translatedValue);
                } else {
                    translatedValue = $translate.instant(translateKey);
                    buildMessage(translatedValue);
                }
            }

            unbindTranslate = $rootScope.$on('$translateChangeSuccess', buildMessage);
            $ctrl.$onDestroy = unbindTranslate;
        }

        function buildMessage(translatedValue) {
            var property = $sce.trustAsHtml('<span class="property">' + propertyPrefix + translatedValue + '</span>');
            var oldValueHtml;
            if (!$ctrl.isCreate) {
                var oldValue = $ctrl.oldValue && $ctrl.oldValue._propertyValue ? $ctrl.oldValue._propertyValue : $ctrl.oldValue;
                oldValueHtml = $sce.trustAsHtml('<span class="old-value">' + formatValue(escapeHtml(oldValue)) + '</span>');
            }
            var newValue = $ctrl.newValue && $ctrl.newValue._propertyValue ? $ctrl.newValue._propertyValue : $ctrl.newValue;
            var newValueHtml = $sce.trustAsHtml('<span class="new-value">' + formatValue(escapeHtml(newValue)) + '</span>');

            var result;
            var currentSanitizationStrategy = $translateSanitization.useStrategy();
            $translateSanitization.useStrategy('sanitize');
            if ($ctrl.isCreate) {
                result = $translate.instant('changeLog.valueCreated', {
                    property: property.toString(),
                    newValue: newValueHtml.toString()
                });
            } else {
                if ((angular.isUndefined(oldValue) || oldValue === null) && newValue) {
                    result = $translate.instant('changeLog.valueAdded', {
                        property: property.toString(),
                        newValue: newValueHtml.toString()
                    });
                } else if (oldValue && (angular.isUndefined(newValue) || newValue === null)) {
                    result = $translate.instant('changeLog.valueRemoved', {
                        property: property.toString(),
                        oldValue: oldValueHtml.toString()
                    });
                } else {
                    result = $translate.instant('changeLog.valueChanged', {
                        property: property.toString(),
                        oldValue: oldValueHtml.toString(),
                        newValue: newValueHtml.toString()
                    });
                }
            }
            $translateSanitization.useStrategy(currentSanitizationStrategy);

            $ctrl.translatedMessage = $sce.trustAsHtml(result);
        }

        function formatValue(value) {
            if (value) {
                const dateOnlyFormat = 'YYYY-MM-DD';
                if (moment(value, dateOnlyFormat, true).isValid()) {
                    return moment(value).format(DATE_FORMAT);
                } else if (moment(value, moment.ISO_8601, true).isValid()) {
                    return moment(value).format(DATE_TIME_FORMAT);
                }
            }
            if (typeof value === 'boolean') {
                return value ? $translate.instant('changeLog.value.true') : $translate.instant('changeLog.value.false');
            }

            return value;
        }

        function escapeHtml(value) {
            if (angular.isString(value)) {
                return value
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#039;')
            } else {
                return value;
            }
        }
    }
})();
